<template>
    <el-dialog @opened="cshData" :visible.sync="riverCz.openShow" :show-close="false" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" top="110px">
        <div style="box-sizing: border-box;padding: 20px;height: 100%;">
            <div style="background-color: #f7f7f7;height: 100%;">
                <div style="display: flex;align-items: center;">
                    <img src="@/assets/icons/monitor/station.svg" style="height: 30px;width: 30px;margin-left: 30px;margin-right: 10px;">
                    <!-- <div style="color: #323232;font-size: 18px;font-weight: 700;">
                        {{ riverCz.cz.stnm }}
                    </div> -->
                    <div>
                        <el-select v-model="riverCz.cz.stcd" placeholder="请选择" size="small" @change="czqh">
                            <el-option
                                v-for="item in czOptions"
                                :key="item.stcd"
                                :label="item.stnm"
                                :value="item.stcd"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <tab-switch :buttonNamesArr="buttonNamesArr" :delImg="riverCz.openShow" @delImgDeal="delImgDeal" @curTabButtonClickDeal="curTabButtonClickDeal" style="background-color: #f7f7f7;">
                    </tab-switch>
                </div>
                <div v-show="activeName == 0">
                    <div style="margin: 10px 0;width: 100%;">
                        <span style="font-size: 14px;margin-right: 10px;margin-left: 30px;">时段</span>
                        <el-select v-model="orForm.hour" placeholder="请选择" size="small" style="width: 120px;" @change="sjdChange">
                            <el-option
                                v-for="item in sjdOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <span style="font-size: 14px;margin-right: 10px;margin-left: 30px">时间</span>
                        <span v-if="orForm.hour == 0">
                            <el-date-picker
                                v-model="riverCz.sjfw"
                                :clearable=false
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                popper-class='myDatePicker'
                                type="datetimerange"
                                range-separator="到"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                @change="sjChange"
                            >
                            </el-date-picker>
                        </span>
                        <span v-else>
                            <el-date-picker
                                v-model="riverCz.sjfw"
                                :clearable=false
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                popper-class='myDatePicker'
                                type="datetimerange"
                                range-separator="到"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                @change="sjChange"
                            >
                            </el-date-picker>
                        </span>
                        <el-button type="primary" size="small" class="czBut queryButton" @click="oreset">重置</el-button>
                        <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="sjdChange(orForm.hour)">搜索</el-button>
                        <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="exportJygc">
                            <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                            &nbsp;导出
                        </el-button>
                    </div>
                    <el-row :gutter="20" style="padding: 0 20px;" v-loading="rloading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
                        <el-col :span="12">
                            <div v-if="orForm.hour === 0">
                                <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;padding-top: 20px;box-sizing: border-box;position: relative;">
                                    <div style="position: absolute;top: 10px;right: 60px;font-size: 22px;cursor: pointer;z-index: 100;" @click="hyhy">
                                        <i class="el-icon-refresh"></i>
                                    </div>
                                    <div id="chartZxt" class="zxtys"></div>
                                </div>
                            </div>
                            <div v-if="orForm.hour != 0" style="height:calc(100vh - 280px);width: 100%;background-color: #fff;">
                                <div style="height:50%;width: 100%;background-color: #fff;box-sizing: border-box;">
                                    <div id="jychartZxt" class="zxtys"></div>
                                </div>
                                <div style="height:50%;width: 100%;background-color: #fff;box-sizing: border-box;">
                                    <div id="chartZxt" class="zxtys"></div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;position: relative;">
                                <div style="width:100%;height: 100%;">
                                    <el-table height="calc(100vh - 340px)" :data="otableData" border :header-cell-style="{background:'#f9f9ff',color:'#323232','text-align':'center'}" >
                                        <el-table-column v-if="orForm.hour == 0" prop="tm" label="时间" align="center"/>
                                        <el-table-column v-else prop="ht" label="时间" align="center"/>
                                        <el-table-column prop="z" label="水位(m)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.z ? scope.row.z : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="q" label="流量(m³/s)" align="right">
                                            <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.q ? scope.row.q : '-' }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <page-footer
                                    :rForm="orForm"
                                    @size-change="osizeChange"
                                    @current-change="ocurrentChange"
                                    style="position: absolute;bottom: 10px;right: 20px;"
                                >
                                </page-footer>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div v-show="activeName == 1">
                    <div style="margin-top: 20;">
                        <el-row :gutter="20" style="padding: 20px 20px 20px 30px;box-sizing: border-box;">
                            <el-col :span="6" style="font-size: 16px;color: #777777;height:calc(100vh - 260px);background-color: #fff;padding-top: 20px;box-sizing: border-box;line-height: 40px;">
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        测站编码
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.stcd }}</div>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        测站名称
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.stnm }}</div>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        所属水库
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.resName }}</div>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        站类
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.sttpName }}</div>
                                </el-col>
                                <el-col :span="24" style="margin-bottom: 15%;">
                                    <div>
                                        站址
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.stlc }}</div>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        东经
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.lgtd }}</div>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15%;">
                                    <div>
                                        北纬
                                    </div>
                                    <div style="color: #323232;font-size: 18px;">{{ jbxx.lttd }}</div>
                                </el-col>
                            </el-col>
                            <el-col :span="18" style="box-sizing: border-box;overflow: hidden;height:calc(100vh - 260px);">
                                <el-carousel trigger="click" height="calc(100vh - 230px)">
                                    <div v-if="jbxx.imgList">
                                        <el-carousel-item v-for="item in jbxx.imgList" :key="item">
                                            <img :src="fileHost + item.path" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width: 100%;"/>
                                        </el-carousel-item>
                                    </div>
                                    <div v-else style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
                                        <img src="@/assets/images/ysqjc/ylz.jpg" v-if="jbxx.sttp == '0801'"/>
                                        <img src="@/assets/images/ysqjc/hdsww.jpg" v-if="jbxx.sttp == '0802'"/>
                                        <img src="@/assets/images/ysqjc/sksww.jpg" v-if="jbxx.sttp == '0803'"/>
                                        <img src="@/assets/images/ysqjc/sksw.jpg" v-if="jbxx.sttp == '0804'"/>
                                        <img src="@/assets/images/ysqjc/hdsw.jpg" v-if="jbxx.sttp == '0805'"/>
                                    </div>
                                </el-carousel>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-show="activeName == 2" class="commonDiv2">
                    <div style="height:35vh;width: 100%;" v-loading="chartLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading">
                        <div id="lsChart" style="height: 35vh;width: 87vw;"></div>
                    </div>
                    <query-gather 
                        :is-add="false"
                        :cur-input-tip="'请输入流量或水位进行查询'"
                        @qgQueryDeal="lsQuery"
                        @qgResetDeal="resetLsDataDeal"
                        :is-label-button1="authorityMap.isAdd"
                        :is-label-button-text1="'流量计算'"
                        @qgLb1Deal="qgLsLb1Deal"
                    >
                        <div slot="right">
                            <span style="position: absolute;right: 160px;margin-top: -10px;" v-if="isLaunchLs">水位流量配置已启用</span>
                            <span style="position: absolute;right: 160px;margin-top: -10px;" v-else>水位流量配置未启用</span>
                        </div>
                    </query-gather>
                    <div style="margin-right: 2vh;margin-left: 2vh;">
                        <el-table
                            ref="lsTable"
                            :data="lsTableData"
                            v-loading="loading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            border
                            @sort-change="lsSortChange"
                            height="calc(100vh - 660px)"
                            :row-style="tableRowClassName"
                            :header-cell-style="{background:'#f9f9ff',color:'#323232'}"
                        >
                            <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                            </el-table-column>
                            <el-table-column
                                prop="rz"
                                label="水位(m)"
                                align="right"
                                sortable="custom"
                                show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                prop="q"
                                label="流量(m³/h)"
                                align="right"
                                sortable="custom"
                                show-overflow-tooltip>
                            </el-table-column>
                            <!-- <el-table-column label="操作" align="center" width="120" v-if="authorityMap.isUpdate || authorityMap.isDel">
                                <template slot-scope="scope">
                                    <span v-if="authorityMap.isUpdate" @click="lsUpdateDeal(scope.row)">
                                        <el-tooltip content="修改" effect="light">
                                            <img
                                                src="~@/assets/images/operates/edit.png"
                                                alt=""
                                                style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                                            />
                                        </el-tooltip>
                                    </span>
                                    <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
                                        <el-popconfirm
                                            title="确定删除吗？"
                                            @confirm="lsDelDeal(scope.row)"
                                        >
                                            <img
                                                src="~@/assets/images/operates/delete.png"
                                                alt=""
                                                slot="reference"
                                                style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                                            />
                                        </el-popconfirm>
                                    </el-tooltip>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </div>
                    <bottom-pagination
                            :params="params" 
                            @sizeChange="lsHandleSizeChange"
                            @currentChange="lsHandleCurrentChange"
                            style="position: absolute;bottom: 0px;right: 10px;"
                        >
                        </bottom-pagination>
                    <!-- <xz :lsDialog="lsDialog" :isRead="isRead" :isAddLs="isAddLs"></xz> -->
                    <Js :lsDialog="lsDialog" :stcd="riverCz.cz.stcd"></js>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { fileHost } from "@/utils/config";
import pageFooter from "@/components/pageFooter";
import tabSwitch from "@/components/buttonGather/tabSwitch";
import QueryGather from "@/components/buttonGather/queryGather";
import DataDialog from "@/components/tableGather/dataDialog";
import BottomPagination from "@/components/tableGather/bottomPagination";
// import Xz from './xz.vue';
import Js from './js.vue';
export default {
    name: "riverOpen",
    components: {
        pageFooter,
        tabSwitch,
        QueryGather,
        DataDialog,
        BottomPagination,
        // Xz,
        Js,
    },
    props:{
        riverCz:{
            type:Object
        },
    },
    data() {
        let validateRealNum = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                let reg = /^[-+]?[0-9]*\.?[0-9]+$/;
                if (reg.test(value)) {
                    let zs = (value + '').split('.')[0];
                    if (zs.length > 6) {
                        return callback(new Error("该数据最多6位"));
                    }
                    callback();
                } else {
                    return callback(new Error("只能输入数值"));
                }
            }
        };
        return {
            isLaunchLs:false,
            fileHost:fileHost,
            rloading:false,
            csTime:[],
            buttonNamesArr:['水位过程','测站信息'],
            czOptions:[],
            delImg: false,
            activeName: 0,
            sstj:{
                sjd:'监测',
            },
            // 查询表单
            orForm: {
                size: 20,
                current: 1,
                total: 0,
                czOrbh:"",
                hour:0,
            },
            sjdOptions: [
                {
                    value: 0,
                    label: '监测'
                }, {
                    value: 1,
                    label: '一小时'
                }, {
                    value: 3,
                    label: '三小时'
                }, {
                    value: 6,
                    label: '六小时'
                }, {
                    value: 12,
                    label: '十二小时'
                }, {
                    value: 24,
                    label: '二十四小时'
                }
            ],
            jcTime:[],
            otableData:[],
            ozxtndData:{},
            ozxtData:[],
            ozxtDataX:[],
            ozxtDataY1:[],
            ozxtDataY2:[],
            ozxtDataX3:[],
            ozxtDataY3:[],
            jbxx:{},

            abcd:{},
            chartLoading: false,
            authorityMap: {
                isAdd: true,//新增权限
                isUpdate: true,//修改权限
                isDel: true,//删除权限
                isView: true,//查看权限
            },
            lsTableData: [],
            loading:false,
            lsDialog: {//流量水位曲线
                title: "",
                lsFormVisible: false,
                lsJsFormVisible: false,
                data: {},
            },
            isRead: true,
            params: {
                total: 0,
                size: 10,
                current: 1,
            },
            lsOption: {
                grid: {
                    left: '5%',
                    right: '5%',
                    top: '15%',
                    bottom: '15%',
                },
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    name: '流量(m³/h)',
                },
                yAxis: {
                    type: 'value',
                    name: '水位(m)',
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        // smooth: true
                    }
                ]
            },
        };
    },
    methods:{
        isLaunchLsDeal(v) {
            this.isLaunchLs = !v;
            let msg = this.isLaunchLs ? '该配置正在使用,停止后将使用设备实际发送过来数据,是否继续该操作?' : '启用该配置,将根据配置的水位流量对应关系替换设备发送过来的数据,是否继续该操作?';
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let obj = {
                    id: this.riverCz.cz.id,
                    rcurve: !this.isLaunchLs,
                }
                this.request.put('/rm-bstbprp/v1/rcurve', obj).then(res => {
                    if (res.ok) {
                        let rmsg = !this.isLaunchLs ? '启用成功' : '停止成功';
                        this.isLaunchLs = !this.isLaunchLs;
                        this.$message.success(rmsg);
                    } else {
                        this.$message.error(res.error.message);
                        this.isLaunchLs = !v;
                    }
                });
            });
        },
        getCzListByCzLb() {
            this.request.post('/rm-bstbprp/v1/listBySttp', ['0802', '0805']).then(res => {
                if (res.ok) {
                    this.czOptions = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        xgDate(dateStr){
            dateStr = dateStr.substring(0,19);
            dateStr = dateStr.replace(/-/g,'/');
            var timeTamp = new Date(dateStr).getTime();
            return timeTamp;
        },
        delImgDeal(){
            this.riverCz.openShow = false;
            this.orForm.hour = 0;
            this.activeName = 0;
        },
        curTabButtonClickDeal(val){
            this.activeName = val;
            this.czqh();
        },
        czqh(){
            if (this.activeName == 0) {
                this.jygcData();
            } else if (this.activeName == 1) {
                this.jbxxData();
            } else {
                for (let i = 0; i < this.czOptions.length; i++) {
                    if (this.riverCz.cz.stcd == this.czOptions[i].stcd) {
                        this.isLaunchLs = this.czOptions[i].rcurve;
                    }
                }
                this.getLsQxData();
                this.getLsChartData();
            }
        },
        cshData(){
            this.csTime = this.riverCz.sjfw;
            // this.pageAuthorityDeal();
            if (this.riverCz.cz.sttp == '0802') {
                this.buttonNamesArr = ['水位过程','测站信息','水位流量关系']
            } else {
                this.buttonNamesArr = ['水位过程','测站信息']
            }
            this.getCzListByCzLb();
            this.jygcData();
        },
        jygcData(){
            let qwer1 = this.xgDate(this.riverCz.sjfw[0].substr(0,13) + ':00:00');
            let qwer2 = this.xgDate(this.riverCz.sjfw[1].substr(0,13) + ':00:00');
            qwer1 = qwer1/(60*60*1000);
            qwer2 = qwer2/(60*60*1000);
            let qwer = qwer2 - qwer1;
            if (qwer > 8784) {
                this.$message.warning('查询时间不允许超过一年！');
                return;
            }


            if (this.jcTime.length < 1 || this.orForm.hour == 0) {
                this.jcTime = this.riverCz.sjfw;
            }
            this.delImg = this.riverCz.openShow;
            this.zxtData();
            this.bgData();
        },
        sjChange(){
            this.jcTime = this.riverCz.sjfw;
        },
        sjdChange(val){
            // this.$set(this.orForm,'hour',val)
            if (val == 0) {
                this.riverCz.sjfw = this.jcTime;
            } else if (val == 1) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime = this.xgDate(this.jcTime[1] + ':00');
                if (hqTime%(60*60*1000) == 0) {
                    hqTime = new Date(hqTime);
                } else {
                    hqTime = new Date(hqTime + 1 * 60 * 60 * 1000);
                }
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                this.riverCz.sjfw = aaTime;
            } else if (val == 3) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%3 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 3 - ((hqTime1 - hqTime0)/(60*60*1000))%3;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%3 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 3 - ((hqTime1 - hqTime0)/(60*60*1000))%3;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                }
            } else if (val == 6) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%6 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 6 - ((hqTime1 - hqTime0)/(60*60*1000))%6;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%6 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 6 - ((hqTime1 - hqTime0)/(60*60*1000))%6;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                }
            } else if (val == 12) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%12 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 12 - ((hqTime1 - hqTime0)/(60*60*1000))%12;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%12 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 12 - ((hqTime1 - hqTime0)/(60*60*1000))%12;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                }
            } else if (val == 24) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (hqTime1%(60*60*1000) == 0) {
                    if (((hqTime1 - hqTime0)/(60*60*1000))%24 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 24 - ((hqTime1 - hqTime0)/(60*60*1000))%24;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                } else {
                    if (((hqTime1 - hqTime0 + 1)/(60*60*1000))%24 == 0) {
                        var hqTime3 = 0;
                    } else {
                        var hqTime3 = 24 - ((hqTime1 - hqTime0)/(60*60*1000))%24;
                    }
                    var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                    aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                    this.riverCz.sjfw = aaTime;
                }
            }
            this.jygcData();
        },

        frontOneHour (fmt,hqTime) {
            var currentTime = hqTime;
            var o = {
                'M+': currentTime.getMonth() + 1, // 月份
                'd+': currentTime.getDate(), // 日
                'h+': currentTime.getHours(), // 小时
                'm+': currentTime.getMinutes(), // 分
                's+': currentTime.getSeconds(), // 秒
                'q+': Math.floor((currentTime.getMonth() + 3) / 3), // 季度
                'S': currentTime.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentTime.getFullYear() + '').substr(4 - RegExp.$1.length))
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
            return fmt
        },

        zxtData(){
            this.rloading = true;
            if (this.orForm.hour == 0) {
                let htGE = this.riverCz.sjfw[0] + ':00';
                let htLE = this.riverCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mriver/v1/river-pro/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtData = res.data.list;
                        this.ozxtndData = res.data;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.tm);
                            _this.ozxtDataY1.push(value.z);
                            _this.ozxtDataY2.push(value.q);
                        })
                        this.$nextTick(()=>{
                            this.initssChar();
                        });
                    }else{
                        this.$message.error(res.error.message)
                        this.rloading = false;
                    }
                });
            } else {
                let htGE = this.riverCz.sjfw[0].substr(0,13);
                let htLE = this.riverCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                // this.request.get("/rm-hrain/v1/res/hour/rain",{params:a}).then((res) => {
                //     if(res.ok){
                //         let _this = this;
                //         this.ozxtDataX3 = [];
                //         this.ozxtDataY3 = [];
                //         res.data.forEach(function(value,index,obj) {
                //             _this.ozxtDataX3.push(value.ht);
                //             _this.ozxtDataY3.push(value.dhp);
                //         })
                //         this.$nextTick(()=>{
                //             this.initjylChar();
                //         });
                //     }else{
                //         this.$message.error(res.error.message)
                //     }
                // });
                this.request.get("/rm-mriver/v1/river-pro/hour/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtData = res.data.list;
                        let ozxtData1 = res.data.hrainVOList;
                        this.ozxtndData = res.data;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.ht);
                            _this.ozxtDataY1.push(value.z);
                            _this.ozxtDataY2.push(value.q);
                        })
                        this.ozxtDataX3 = [];
                        this.ozxtDataY3 = [];
                        ozxtData1.forEach(function(value,index,obj) {
                            _this.ozxtDataX3.push(value.ht);
                            _this.ozxtDataY3.push(value.dhp);
                        })
                        this.$nextTick(()=>{
                            this.initjylChar();
                            this.initssChar();
                        });
                    }else{
                        this.$message.error(res.error.message)
                        this.rloading = false;
                    }
                });
            }
            
        },
        hyhy(){
            this.initssChar();
        },
        //折线图绘制
        initssChar(){
            let _that = this;
            let ztcd;
            if (this.orForm.hour == 0) {
                ztcd = 16;
            } else if (this.orForm.hour == 1) {
                ztcd = 16;
            } else if (this.orForm.hour == 3) {
                ztcd = 16;
            } else if (this.orForm.hour == 6) {
                ztcd = 16;
            } else if (this.orForm.hour == 12) {
                ztcd = 10;
            } else if (this.orForm.hour == 24) {
                ztcd = 10;
            }


            let zxtCharts = this.$echarts.init(document.getElementById("chartZxt"));
            let option = {
                color: ['#2aa79e','#53abfd'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                    formatter:function(params){
                        var htmlStr = '';
                        for(var i=0;i<params.length;i++){
                            var param = params[i];
                            var xName = param.name;//x轴的名称
                            var seriesName = param.seriesName;//图例名称
                            var value = param.value;//y轴值
                            var color = param.color;//图例颜色
                            
                            if(i===0){
                            htmlStr += xName + '<br/>';//x轴的名称
                            }
                            htmlStr +='<div>';
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                
                            // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                            //htmlStr += '<span style="color:'+color+'">';
                            
                            //圆点后面显示的文本
                            htmlStr += seriesName + '：' + (value ? value :'-');
                
                            // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                            //htmlStr += '</span>';
                            
                            htmlStr += '</div>';
                        }
                        if (_that.ozxtndData.ensureZ) {
                            htmlStr += '<div style="color:#ea3323">保证水位(m)：'+ _that.ozxtndData.ensureZ +'</div>'
                        }
                        if (_that.ozxtndData.alertZ) {
                            htmlStr += '<div style="color:#fa9001">警戒水位(m)：'+ _that.ozxtndData.alertZ +'</div>'
                        }
                        return htmlStr;
                    }
                },
                toolbox: {
                    right: 10,
                    feature: {
                        dataZoom: {
                            show: this.orForm.hour == 0 ? true : false,
                            iconStyle:{ //不需要图标可以设置隐藏按钮
                                opacity:0
                            },
                            yAxisIndex: 'none'
                        }
                    }
                },
                grid: {
                    left: '8%',
                    right: '8%',
                    bottom: '8%',
                    top: '11%',
                },
                legend: {
                    data: ['水位(m)', '流量(m³/s)']
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,//x轴两边不留空白
                    data: this.ozxtDataX,
                    axisLabel:{
                        formatter : function(params){
                            return _that.controlShowLength(params, ztcd);
                        }
                    },
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '水位(m)',
                        scale:true,
                        max: function (value) {
                            let maxZ;
                            if (_that.ozxtndData.ensureZ) {
                                maxZ = (parseFloat(_that.ozxtndData.ensureZ) + (0.01 * parseFloat(_that.ozxtndData.ensureZ))).toFixed(0);
                            } else {
                                maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                            }
                            if (parseFloat(_that.ozxtndData.maxZ)>parseFloat(_that.ozxtndData.ensureZ)) {
                                maxZ = (parseFloat(_that.ozxtndData.maxZ) + (0.01 * parseFloat(_that.ozxtndData.maxZ))).toFixed(0);
                            }
                            let cc = parseFloat(maxZ) + parseFloat(10 - maxZ%10);
                            return cc;
                        },
                        min: function (value) {
                            let minZ;
                            if (_that.ozxtndData.alertZ) {
                                minZ = (parseFloat(_that.ozxtndData.alertZ) - (0.01 * parseFloat(_that.ozxtndData.alertZ))).toFixed(0);
                            } else {
                                minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                            }
                            if (parseFloat(_that.ozxtndData.minZ)<parseFloat(_that.ozxtndData.alertZ)) {
                                minZ = (parseFloat(_that.ozxtndData.minZ) - (0.01 * parseFloat(_that.ozxtndData.minZ))).toFixed(0);
                            }
                            let cc = parseFloat(minZ) + parseFloat(10 - minZ%10);
                            return cc;
                        },
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(43, 167, 158)',
                            },
                        },
                    },
                    {
                        type: 'value',
                        name: '流量(m³/s)',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(83, 171, 253)',
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: '水位(m)',
                        data: this.ozxtDataY1,
                        yAxisIndex: 0,
                        type: 'line',
                        smooth: true,
                        areaStyle: {
                            color: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(43, 167, 158, 0.7) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.9,
                                        color: 'rgba(43, 167, 158, 0.1)' // 100% 处的颜色
                                    }
                                ]
                            }
                        },
                        markLine: {
                            symbol: ['none'], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                            label:{
                                position:"start" //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                            },
                            data : [
                                {
                                    silent:true,
                                    lineStyle:{
                                        type:"dashed",
                                        color:"#ea3323",
                                        width: 2
                                    },
                                    yAxis: this.ozxtndData.ensureZ ? this.ozxtndData.ensureZ : '-',
                                    label: {
                                        normal: {
                                            formatter: '保证水位',
                                            color: '#ea3323',
                                        },
                                    }
                                },
                                {
                                    silent:true,
                                    lineStyle:{
                                        type:"dashed",
                                        color:"#fa9001",
                                        width: 2
                                    },
                                    yAxis: this.ozxtndData.alertZ ? this.ozxtndData.alertZ : '-',
                                    label: {
                                        normal: {
                                            formatter: '警戒水位',
                                            color: '#fa9001',
                                        }
                                    }
                                },
                            ]
						}
                    },
                    {
                        name: '流量(m³/s)',
                        data: this.ozxtDataY2,
                        yAxisIndex: 1,
                        type: 'line',
                        smooth: true,
                        areaStyle: {
                            color: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(83, 171, 253, 0.7) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.9,
                                        color: 'rgba(83, 171, 253, 0.1)' // 100% 处的颜色
                                    }
                                ]
                            }
                        }
                    }
                ]
            };
            zxtCharts.setOption(option,true);
            zxtCharts.resize();
            window.addEventListener("resize", function () {
                zxtCharts.resize();
            });
            this.rloading = false;
            //开启默认选中区域缩放
            zxtCharts.dispatchAction({
                type:'takeGlobalCursor',
                key:'dataZoomSelect',
                dataZoomSelectActive:true
            })
        },
        controlShowLength(params, length){
            if (length != null) {
                if (length == 16) {
                    params = params.substring(0, 13) + ':00';
                } else {
                    params = params.substring(0, length);
                }
            }
            var newParamsName = "";
            // var paramsNameNumber = params.length;
            // var provideNumber = 4;
            // var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
            // if (paramsNameNumber > provideNumber) {
            //     for (var p = 0; p < rowNumber; p++) {
            //         var tempStr = "";
            //         var start = p * provideNumber;
            //         var end = start + provideNumber;
            //         if (p == rowNumber - 1) {
            //             tempStr = params.substring(start, paramsNameNumber);
            //         } else {
            //             tempStr = params.substring(start, end) + "\n";
            //         }
            //     newParamsName += tempStr;
            //     }
            // } else {
            //     newParamsName = params;
            // }
            newParamsName = params;
            return newParamsName
        },
        initjylChar(){
            let _that = this;
            let ztcd;
            if (this.orForm.hour == 0) {
                ztcd = 16;
            } else if (this.orForm.hour == 1) {
                ztcd = 16;
            } else if (this.orForm.hour == 3) {
                ztcd = 16;
            } else if (this.orForm.hour == 6) {
                ztcd = 16;
            } else if (this.orForm.hour == 12) {
                ztcd = 10;
            } else if (this.orForm.hour == 24) {
                ztcd = 10;
            }
            let jyzxtCharts = this.$echarts.init(document.getElementById("jychartZxt"));
            jyzxtCharts.clear();
            let option = {
                color: ['#2c83ea'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                },
                grid: {
                    left: '8%',
                    right: '8%',
                    bottom: '15%',
                    top: '8%',
                },
                // legend: {
                //     data: ['降雨量(mm)']
                // },
                xAxis: {
                    data: this.ozxtDataX3,
                    type: 'category',
                    boundaryGap: false,//x轴两边不留空白
                    position: 'top',
                    axisLabel:{
                        formatter : function(params){
                            return _that.controlShowLength(params, ztcd);
                        }
                    },
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '降雨量(mm)',
                        inverse: true,
                        alignTicks: true,
                        axisLine: {
                            show: true,
                        },
                    },
                ],
                series: [
                    {
                        name: '降雨量(mm)',
                        type: 'bar',
                        data: this.ozxtDataY3,
                        barWidth: 8, // 柱状图的宽度
                        itemStyle: {
                            color: '#0675e9',
                        }
                    },
                ]
            };
            jyzxtCharts.setOption(option);
            window.addEventListener("resize", function () {
                jyzxtCharts.resize();
            });
        },
        bgData(){
            if (this.orForm.hour == 0) {
                let htGE = this.riverCz.sjfw[0] + ':00';
                let htLE = this.riverCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mriver/v1/river-pro/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.rloading = false;
                    }
                });
            } else {
                let htGE = this.riverCz.sjfw[0].substr(0,13);
                let htLE = this.riverCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get("/rm-mriver/v1/river-pro/hour/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.rloading = false;
                    }
                });
            }
        },
        oreset() {
            this.orForm.hour = 0;
            // this.sjdChange(0);
            this.riverCz.sjfw = this.csTime;
            this.jygcData();
        },
        // 切换分页
        ocurrentChange(val) {
            this.orForm.current = val;
            this.bgData();
        },
        // 显示最大条数变动
        osizeChange(val) {
            this.orForm.size = val;
            this.bgData();
        },
        exportJygc(){
            if (this.orForm.hour == 0) {
                let htGE = this.riverCz.sjfw[0].substr(0,13) + ':00:00';
                let htLE = this.riverCz.sjfw[1].substr(0,13) + ':00:00';
                let b = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get('/rm-mriver/v1/river-pro/export',{ params: b,responseType: "blob" }).then((res) => {
                    try {
                        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        // 这里填保存成的文件名
                        a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                        a.click();
                        URL.revokeObjectURL(a.href);
                        return;
                    } catch (error) {
                        const reader = new FileReader(); 
                        reader.readAsText(res.data, 'utf-8');
                        let _this = this;
                        reader.onload=function(){
                            const msg = JSON.parse(reader.result);
                            if (!msg.ok) {
                                if (msg.error.code == 3001) {
                                    _this.$message.error(msg.error.message);
                                } else {
                                    _this.$message.warning(msg.error.message);
                                }
                            }
                        }
                    }
                });
            } else {
                let htGE = this.riverCz.sjfw[0];
                let htLE = this.riverCz.sjfw[1];
                let b = {
                    ...this.orForm,
                    stcd:this.riverCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get('/rm-mriver/v1/river-pro/hour/export',{ params: b,responseType: "blob" }).then((res) => {
                    try {
                        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        // 这里填保存成的文件名
                        a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                        a.click();
                        URL.revokeObjectURL(a.href);
                        return;
                    } catch (error) {
                        const reader = new FileReader(); 
                        reader.readAsText(res.data, 'utf-8');
                        let _this = this;
                        reader.onload=function(){
                            const msg = JSON.parse(reader.result);
                            if (!msg.ok) {
                                if (msg.error.code == 3001) {
                                    _this.$message.error(msg.error.message);
                                } else {
                                    _this.$message.warning(msg.error.message);
                                }
                            }
                        }
                    }
                });
            }
        },

        jbxxData(){
            this.request.get("/rm-bstbprp/v1/getInfoByStcd/"+this.riverCz.cz.stcd).then((res) => {
                if(res.ok){
                    this.jbxx = res.data;
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },

        pageAuthorityDeal() {
            const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
            const qx = thirdAuthority[this.$route.name];
            if (qx === 'all' || qx === null) {
                this.authorityMap.isAdd = true;
                this.authorityMap.isDel = true;
                this.authorityMap.isUpdate = true;
                this.authorityMap.isView = true;
            } else {
                this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
                this.authorityMap.isDel = qx.indexOf('删除') !== -1;
                this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
                this.authorityMap.isView = qx.indexOf('查询') !== -1;
            }
        },
        getLsQxData() {
            this.loading = true;
            let x = {
                ...this.params
            };
            x.stcd = this.riverCz.cz.stcd;
            this.request.get('/rm-brcurve/queryPage', {params: x}).then(res => {
                if (res.ok) {
                if (res.data != null) {
                    this.lsTableData = [];
                    this.lsTableData = res.data['records'];
                    this.params.total = res.data.total;
                    this.params.size = res.data.size;
                }
                } else {
                    this.$message.error(res.error.message);
                }
                this.loading = false;
            });
        },
        lsQuery(params) {
            this.curInputValue = params.curInputValue;
            this.params.current = 1;
            this.params.sz = this.curInputValue;
            this.getLsQxData();
        },
        resetLsDataDeal() {
            this.curInputValue = '';
            this.params = {
                total: 0,
                size: 10,
                current: 1,
            };
            this.$refs.lsTable.clearSort();
            this.getLsQxData();
            this.getLsChartData();
        },
        getLsChartData() {
            this.chartLoading = true;
            let lsCharts = this.$echarts.init(document.getElementById("lsChart"));
            this.request.get('/rm-brcurve/v1/'+this.riverCz.cz.stcd).then(res => {
                if (res.ok) {
                    if (res.data != null) {
                        let x = [];
                        let y = [];
                        for (let i = 0; i < res.data.length; i++) {
                            x.push(res.data[i]['rz']);//水位
                            y.push(res.data[i]['q']);//流量
                        }
                        this.lsOption.xAxis.data = [];
                        this.lsOption.xAxis.data = [...y];
                        this.lsOption.series[0].data = [];
                        this.lsOption.series[0].data = [...x];
                        lsCharts.setOption(this.lsOption, true);
                    } else {
                        this.lsOption.xAxis.data = [];
                        this.lsOption.series[0].data = [];
                        lsCharts.setOption(this.lsOption, true);
                    }
                } else {
                    this.$message.error(res.error.message);
                }
            });
            this.chartLoading = false;
        },
        qgLsLb1Deal() {
            this.lsDialog.title = '根据水位计算流量';
            // this.lsDialog.data = {...this.lsData};
            this.lsDialog.lsJsFormVisible = true;
        },
        lsSortChange(column) {
            let params = {
                total: 0,
                size: 10,
                current: 1,
                sortCol: column.prop.toUpperCase(),
                order: column.order === "descending" ? 1 : 0,
            };
            this.params = {};
            this.params = params;
            this.getLsQxData();
        },
        tableRowClassName({row, rowIndex}) {
            return {
                backgroundColor: '#ffffff',
                fontSize: '1.2rem',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontFamily: 'PingFang SC',
                color: '#616f7b',
                height: '4vh',
            };
        },
        lsHandleSizeChange(val) {
            this.params.size = val;
            this.params.current = 1;
            this.getLsQxData();
        },
        lsHandleCurrentChange(val) {
            this.params.current = val;
            this.getLsQxData();
        },
    },
}
</script>

<style scoped>
::v-deep .el-dialog{
    margin-bottom:0;
    width: 100%; 
    height: calc(100% - 110px);
}
::v-deep .el-dialog__header{
    display: none;
}
::v-deep .el-dialog__footer{
    display: none;
}
::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
}
.zxtys{
    height: 100%;
    width: 100%;
}

/* 按钮样式 */
.queryButton {
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    margin-left: 1.5rem;
}
.czBut {
    background-color: #a8a8a8;
    border: solid 0rem #f4f4f4;
}
.queryButtonPadding {
    padding-left: 2rem;
    padding-right: 2rem;
}
.qDcImg {
    width: 1.2rem;
    height: 1.2rem;
}
.qDcBtn {
    position: absolute;
    right: 4rem;
}

.commonDiv2 {
    position: relative;
    background-color: #FFFFFF;
    margin: 0 2rem;
    padding: 0;
    height:calc(100vh - 220px);
    /* width: 100%; */
    background-color: #fff;
}
</style>
